export default __webpack_public_path__ + "images/icomoon_3ececdf5d1b7093893c8ae8daa8722fd.svg";